import React from 'react';
import { useLanguage } from '../i18n/useLanguage';

interface StaticPageProps {
  titleKey: string;
  children: React.ReactNode;
}

export const StaticPage: React.FC<StaticPageProps> = ({ titleKey, children }) => {
  const { t } = useLanguage();
  return (
    <div className="static-page">
      <h1 className="static-page-title">{t(titleKey as any)}</h1>
      <div className="static-page-content">{children}</div>
    </div>
  );
};
